import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import * as Auth from "../../../Login/Auth"
import { SingleInput, SingleRedio } from '../../Res/BaseInput';
import { CancelSubmitButton } from '../../Res/BaseButton';
import { ContentBox } from '../../Content/ContentBox';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { ReqRoleAdd, ReqRoleDetail, RespRoleDetail, ReqUpdateRole } from '../../../../item/ItemRole';
import { api_addRole, api_getRoleDetail, api_updateRole } from '../../../../api/apiRole';
import { ReqUpdateDepartment } from '../../../../item/ItemDepartment';
import { DepartmentPositionPermissionList } from './DepartmentPositionPermissionList';


export function DepartmentPositionEdit({ id, setIsLoading }) {
  const [departmentId, setDepartmentId] = useState("")
  const [roleId, setRoleId] = useState("")
  const [roleName, setRoleName] = useState("")
  const [isSupervisor, setIsSupervisor] = useState(0)

  useEffect(() => {
    setRoleId(id)
    getDetail(id)
  }, [])

  useEffect(()=>{
    console.log(departmentId)
  },[departmentId])


  function toCancel() {
    window.history.back();
  }

  function getDetail(roleId) {
    setIsLoading(true)
    var mReqRoleDetail = new ReqRoleDetail({ roleId })
    console.log(mReqRoleDetail)
    api_getRoleDetail({
      mReqRoleDetail,
      success: (jsonData) => {
        var mRespRoleDetail = new RespRoleDetail({})
        mRespRoleDetail.fromJson(jsonData.detail)
        setRoleName(mRespRoleDetail.roleName)
        setIsSupervisor(mRespRoleDetail.isSupervisor)
        setDepartmentId(mRespRoleDetail.departmentId)
        setIsLoading(false)
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
      }
    })
  }

  function toEdit() {
    if (roleName !== "") {
      var mReqUpdateRole = new ReqUpdateRole({
        departmentId,
        roleId,
        roleName,
        isSupervisor
      })
      console.log(mReqUpdateRole)
      api_updateRole({
        mReqUpdateRole,
        success: (jsonData) => {
          Swal.fire({
            type: 'success',
            title: '提醒',
            text: '修改成功',
            allowEscapeKey: false,
            allowOutsideClick: false
          }).then(function () {
            window.history.back(-1);
          })
        },
        failure: (err) => {
          Swal.fire({
            type: 'error',
            title: '提醒',
            text: err,
          })
        }
      })
    } else {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: '職稱 不得為空',
      })
    }
  }

  const isSupervisorItems = [
    { "val": 1, "name": "主管" },
    { "val": 0, "name": "員工" },
  ]

  var title = "職務資訊"
  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          <SingleInput title={"職稱"} val={roleName} action={setRoleName} placeholder={"經理、專員"} size={4} />

          <SingleRedio title={"級別"}
            arr={isSupervisorItems}
            val={isSupervisor ? 1 : 0}
            action={setIsSupervisor}
            size={4}
          />
        </div>
      </div>
    </>

  var footer =
    <div className="row">
      <div className="col-sm-3 col-sm-offset-9">
        <CancelSubmitButton cancelAction={toCancel} submitName={"儲存"} submitAction={toEdit} isRight={true} />
      </div>
    </div>

  return (
    <>
      <ContentBox title={title} content={content} footer={footer} hasDrawer={true} />
      <DepartmentPositionPermissionList id={roleId} setIsLoading={setIsLoading} />
      <SystemPromptInput />
    </>
  )
}